var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgOriMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector 6",
    filter: "url(#filter0_i_0_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49766 0.892024C7.37295 0.960169 7.24924 1.0315 7.12666 1.10558C3.61236 3.22945 0.658213 6.73791 0.0807775 10.8033C-0.1708 12.5745 0.204895 13.9571 0.662165 15.1429C1.5166 17.3586 3.36789 19.4313 5.7888 21.2297C8.2097 23.028 12.4819 23.1664 14.0483 22.8897C15.6148 22.613 17.6085 22.2004 18.7477 21.2297C19.887 20.2589 22.4503 18.0479 23.3047 15.8346C24.1592 13.6212 24.3016 11.1288 23.3047 8.63881C22.031 5.4571 21.8807 5.18276 18.4629 2.27772C15.0452 -0.627314 9.77616 -0.352992 7.49766 0.892024Z",
    fill: "#FFE03A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49766 0.892024C7.37295 0.960169 7.24924 1.0315 7.12666 1.10558C3.61236 3.22945 0.658213 6.73791 0.0807775 10.8033C-0.1708 12.5745 0.204895 13.9571 0.662165 15.1429C1.5166 17.3586 3.36789 19.4313 5.7888 21.2297C8.2097 23.028 12.4819 23.1664 14.0483 22.8897C15.6148 22.613 17.6085 22.2004 18.7477 21.2297C19.887 20.2589 22.4503 18.0479 23.3047 15.8346C24.1592 13.6212 24.3016 11.1288 23.3047 8.63881C22.031 5.4571 21.8807 5.18276 18.4629 2.27772C15.0452 -0.627314 9.77616 -0.352992 7.49766 0.892024Z",
    fill: "url(#paint0_radial_0_12)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_0_12",
    x: 0,
    y: 0,
    width: 24,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.682353 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_12"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_12",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 11.5) rotate(90) scale(3.71687 3.87847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriMark);
export default __webpack_public_path__ + "static/media/ori-mark.5d61a08aadad51174309d0aa16feb217.svg";
export { ForwardRef as ReactComponent };